export const nik = (value: string) => {
  const regex = /^[0-9]{16}$/;
  return regex.test(value);
};

export const email = (value: string) => {
  const regex = /^([\w.])*?([a-z0-9])+@([\w-]+\.)+[\w-]{2,}$/;
  return regex.test(value);
};
